export default __webpack_public_path__ + "static/media/government.5e538e16.svg";